import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import BottomNavigation from '../components/BottomNavigation';
import './AllResources.css';

const AllResources: React.FC = () => {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  const [sortBy, setSortBy] = useState('popular');

  const resources = [
    { id: 1, title: 'Mathematics Fundamentals', author: 'John Doe', type: '📖 Book', rating: 4.8, price: 19 },
    { id: 2, title: 'English Grammar Guide', author: 'Jane Smith', type: '📖 Book', rating: 4.9, price: 15 },
    { id: 3, title: 'Science Encyclopedia', author: 'Dr. Brown', type: '📖 Book', rating: 4.7, price: 25 },
    { id: 4, title: 'History Timeline', author: 'Prof. Davis', type: '📖 Book', rating: 4.6, price: 20 },
    { id: 5, title: 'Physics Formulas', author: 'Dr. Wilson', type: '📄 PDF', rating: 4.8, price: 12 },
    { id: 6, title: 'Chemistry Lab Manual', author: 'Ms. Taylor', type: '📖 Book', rating: 4.5, price: 18 }
  ];

  const filteredResources = resources.filter(resource =>
    resource.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
    resource.author.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const sortedResources = [...filteredResources].sort((a, b) => {
    switch (sortBy) {
      case 'price-low':
        return a.price - b.price;
      case 'price-high':
        return b.price - a.price;
      case 'rating':
        return b.rating - a.rating;
      default:
        return b.rating - a.rating;
    }
  });

  return (
    <div className="all-resources-page">
      <header className="all-resources-header">
        <button className="back-button" onClick={() => navigate(-1)}>
          ←
        </button>
        <h1>All Resources</h1>
        <div className="header-spacer"></div>
      </header>

      <div className="all-resources-content">
        {/* Search Bar */}
        <div className="search-bar-container">
          <span className="search-icon">🔍</span>
          <input
            type="text"
            placeholder="Search resources..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="search-input-large"
          />
        </div>

        {/* Sort Options */}
        <div className="sort-options">
          <span className="sort-label">Sort by:</span>
          <select
            value={sortBy}
            onChange={(e) => setSortBy(e.target.value)}
            className="sort-select"
          >
            <option value="popular">Most Popular</option>
            <option value="rating">Highest Rated</option>
            <option value="price-low">Price: Low to High</option>
            <option value="price-high">Price: High to Low</option>
          </select>
        </div>

        {/* Results Count */}
        <div className="results-count">
          {sortedResources.length} resource{sortedResources.length !== 1 ? 's' : ''} found
        </div>

        {/* Resources List */}
        <div className="resources-list-all">
          {sortedResources.map((resource) => (
            <div
              key={resource.id}
              className="resource-card-all"
              onClick={() => navigate(`/resource/${resource.id}`)}
            >
              <div className="resource-icon-all">{resource.type}</div>
              <div className="resource-info-all">
                <h3 className="resource-title-all">{resource.title}</h3>
                <p className="resource-author-all">{resource.author}</p>
                <div className="resource-meta-all">
                  <span className="resource-rating-all">⭐ {resource.rating}</span>
                  <span className="resource-price-all">${resource.price}</span>
                </div>
              </div>
              <button className="pay-button-all">Pay</button>
            </div>
          ))}
        </div>
      </div>

      <BottomNavigation />
    </div>
  );
};

export default AllResources;
